import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { VehicleStatusEnum } from '../../vehicles/enums/vehicle-status.enum';

/**
 * Vehicle availability tracking options DTO
 */
export class VehicleAvailabilityTrackingOptionsDto extends BaseDto {
	status!: VehicleStatusEnum;
	isAvailable!: boolean;
}
